import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { ISystemNotification } from '../../models/SystemNotificationType';

export interface IOrdersState {
    notification: ISystemNotification | null;
}

const initialState: IOrdersState = {
    notification: null,
};

export const systemNotificationSlice = createSlice({
    name: 'systemNotification',
    initialState,
    reducers: {
        addNotification: (state, action: PayloadAction<ISystemNotification>) => {
            state.notification = action.payload;
        },
        clearNotifications: (state) => {
            state.notification = null;
        },
    },
});

export const { addNotification, clearNotifications } = systemNotificationSlice.actions;

export default systemNotificationSlice.reducer;
